import { parseLoadSubsetOptions } from "@tanstack/db";
import type { SupportTicketCollectionFilter } from "./support-ticket-collection-scope";

export function parseCollectionFilters(
  loadSubsetOptions: unknown,
): readonly SupportTicketCollectionFilter[] {
  const { filters } = parseLoadSubsetOptions(
    // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
    loadSubsetOptions as Parameters<typeof parseLoadSubsetOptions>[0],
  );
  return filters;
}
